import "./src/styles/global.css";
import "prismjs/themes/prism.css";
import "katex/dist/katex.min.css";
import "@fontsource/roboto";
import "@fontsource-variable/montserrat";
import "@fontsource-variable/victor-mono";
// import fontawesome css manually and set this config
// to prevent icon sizing issue
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
config.autoAddCss = false;
